// Riproducibilità dei video nel browser.
//
// Il BE converte i video in mp4; finché la conversione non c'è l'anteprima punta
// all'originale, che per questi contenitori il browser non riproduce. In quel
// caso la UI mostra "Scarica originale" al posto del player.

export const NON_STREAMABLE_VIDEO_EXTS = ['mts', 'm2ts', 'avi', 'mkv', 'mpg', 'mpeg', 'wmv', 'flv'];

/** Estensione del path di un URL (presigned S3: la chiave conserva il nome file). */
export const urlPathExt = (url?: string | null): string => {
    if (!url) return '';
    let path = url.split('#')[0].split('?')[0];
    try { path = decodeURIComponent(path); } catch { /* path non decodificabile: usa raw */ }
    const last = path.split('/').pop() || '';
    const dot = last.lastIndexOf('.');
    return dot >= 0 ? last.slice(dot + 1).toLowerCase() : '';
};

/** false se l'URL punta a un contenitore video che il browser non riproduce (es. .MTS originale). */
export const isBrowserPlayableVideoUrl = (url?: string | null): boolean =>
    !!url && !NON_STREAMABLE_VIDEO_EXTS.includes(urlPathExt(url));
